import React            from 'react';
import Fretboard from './Fretboard';
import InstructionLabel from "./InstructionLabel";

class GuitarExChild extends React.Component {
    constructor(props) {
        super(props);


        this._fretStart = this.props.fretStart
        this._fretEnd   = this.props.fretEnd
        this._scale     = this.props.scale
        this._title     = this.props.title
        this._url       = this.props.url
        this._helpLink  = this.props.helpLink

        this.state      = { _buttonStyle:"btn btn-dark col-12",
            notes:this.props.notes,
            titleColorStyle:null,
            hidedots:true,
            successIcon:false,
        };
    }

    getHelpLink(helpLink) {

        if(helpLink !== "#") {
            return (<a href={helpLink}>
                <svg xmlns="http://www.w3.org/2000/svg"  width="16" height="16" fill="currentColor" className="bi bi-info-circle icon-xl" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                </svg>
            </a>)
        }
    }

    getIcon() {
        if(this.state.successIcon) {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-square icon-xl" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                    <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"/>
                </svg>)
        }
        else {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-square icon-xl" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                </svg>
            )
        }
    }
    ChangeColor(buttonStyle, that) {
        that.setState({_buttonStyle: buttonStyle,
            titleColorStyle:'exercise_success', hidedots:false,
            successIcon:true});
    }

    getButton() {
        return (
            <button className={this.state._buttonStyle}>
                <div>
                    <span>Next&nbsp;&nbsp;</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-circle" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                    </svg>
                </div>
            </button>
        )
    }

    render() {

        return (
            <div>


            <div className="container">

                <div className="row">
                    <div className="col-sm-1" id='test'></div>
                    <div className="col-sm-10" id='midrow'>
                        <h1  className={this.state.titleColorStyle}>{this._title}&nbsp;&nbsp;
                            {this.getHelpLink(this._helpLink)}
                            &nbsp;&nbsp;
                            {this.getIcon() }

                        </h1>
                        <InstructionLabel scale={this._scale}  notes={this.state.notes}
                                          fretStart={this._fretStart} fretEnd={this._fretEnd}></InstructionLabel>


                        <Fretboard notes={this.state.notes} fretStart={this._fretStart}fretEnd={this._fretEnd} callback={this.ChangeColor} that={this} helpNotes={null} hidedots={this.state.hidedots}  />

                    </div>
                </div>

                <div className="row float-right">
                    <div className="col-sm-1"></div>
                    <div className="col-sm-10 float-right" id='bottomrow'>
                        <h1>
                            <a href={this._url} >
                                {this.getButton()}
                            </a>
                        </h1>
                        <div className="col-sm-1"></div>
                    </div>
                </div>
            </div>
            </div>
        );}
}
export default GuitarExChild;
